module.exports = __webpack_public_path__ + "img/upload.42adc35e.png";